export function timeToMin(t: string): number {
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
}

export function overlap(a1: string, a2: string, b1: string, b2: string): boolean {
  return timeToMin(a1) < timeToMin(b2) && timeToMin(b1) < timeToMin(a2);
}
